import script from "./InputNumber.vue.js?vue&type=script&lang=js!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InputNumber.vue?vue&type=script&lang=js"
export * from "./InputNumber.vue.js?vue&type=script&lang=js!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InputNumber.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__